import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=4f5065c0&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=4f5065c0&lang=scss&scoped=true&"
import style1 from "./BaseButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5065c0",
  null
  
)

export default component.exports